export const AppSearchEngines = {
	LISTINGS: 'listings',
	CATEGORIES: 'categories',
	COLLECTIONS: 'collections',
	BLOG_POSTS: 'blog-posts',
};

// Via: core.CancelReasonType
export const CancelReasonType = {
	FINANCIAL_REASON: 1,
	TEST_IT_OUT: 2,
	ACCIDENTAL_ORDER: 3,
	RESUBSCRIBE_LATER: 4,
	SHIPPING_ISSUES: 5,
	NOT_WORTH_PRICE: 6,
	DID_NOT_LIKE_PRODUCT: 7,
	OTHER_SERVICE_ISSUE: 8,
	TRYING_OTHER_SERVICE: 9,
	OTHER: 10,
	MERCHANT_CANCELLED: 11,
	PREVENT_RENEWAL: 12,
	BILLED_TWICE: 13,
	FRAUD: 14,
	GIFT: 15,
	NOT_RECEIVED_ON_TIME: 16,
	DAMAGED_MISSING_PRODUCT: 17,
	CUSTOMER_SERVICE_ISSUE: 18,
	NEED_BREAK: 19,
};

export const ImageType = {
	PRIMARY_IMAGE: 1,
	OTHER_IMAGE: 2,
	UNUSED_IMAGE: 3,
};

// Maps to mp.ImageInstanceVersion
export const ImageInstanceVersion = {
	raw: 0,
	transform: 1,
};

export const CdnBucketMap = {
	'cj-filestack': 'd17qo5cceyilur',
	'cratejoy-marketplace-images': 'd3lri94xwt3wfr',
	'cratejoy_vendor_images': 'd3a1v57rabk2hm',
};

// Via: mp.ListingLinkType
export const ListingLinkType = {
	instagram: 1,
	pinterest: 2,
	twitter: 3,
	facebook: 4,
	custom: 5,
	youtube: 6,
};

export const SubscriptionStatus = {
	unpaid: 1,
	active: 2,
	cancelled: 3,
	suspended: 4,
	expired: 5,
	past_due: 6,
	pending_renewal: 7,
	renewing: 8,
	unpaid_order_failed: 9,
	transferred: 10
};

// Matching contentful_lib.py
export const ContentfulTypes = {
	about_page: "aboutPage",
	home_page: "homepageHero",
	homepage_notable: "homepageNotable",
	homepage_lilwidget: "homepageLilwidget",
	homepage_slide: "homepageSlide",
	collection_hub: "collectionsHub",
	collection_header: "collectionHeader",
	collection_editors_pick: "collectionEditorsPick",
	collection_single: "collectionSingle",
	collection_selection: "collectionSelection",
	collection_visual_break: "collectionVisualBreak",
	collection_signup: "collectionSignup",
	embed_social_feed: "embedSocialFeed",
};

export const AccessLevel = {
	STORE_ADMIN: 1,
	CRATEJOY_ADMIN: 2,
	STORE_OPERATOR: 3,
	MARKETPLACE_AUTHOR: 4,
};

// cratejoy.models.core.enums
export const OrderGiftInfoDeliveryMethod = {
	email: 1,
	sms: 2,
	printable: 3,
};

// cratejoy.models.core.enums
export const OrderGiftInfoOccasion = {
	birthday: 1,
	christmas : 2,
	mothers_day : 3,
	fathers_day : 4,
	anniversary : 5,
	valentines : 6,
	easter : 7,
	back_to_school : 8,
	other : 9,
};

// cratejoy.models.core.enums
export const OrderGiftInfoRelationship = {
	myself: 1,
	child: 2,
	friend_or_relative: 3,
	significant_other: 4,
};

export const ScrollEdge = 0.95;

export const BadgeTypes = {
	tracking: 0,
	fast: 1,
	gifting: 2,
	pros: 3,
	order_by: 4,
	new_arrival: 5,
	best_of_best: 6,
	best_new_box: 7,
	editors_picks: 8,
	top_rated: 9,
	best_in_category: 10,
};

export const QuestionTypes = {
	post_purchase: {
		other: "Other",
		havent_recieved_shipment: "I haven't received my shipment",
		change_subscription: "Change Subscription",
		shipping_question: "Question About Shipping",
		problem_w_product: "Problem With the Product",
		default: "What do you need help with?",
	},
	pre_purchase: {
		other: "Other",
		customize_order: "Customize Order",
		special_shipping_request: "Special Shipping Request",
		details_about_box: "Details About the Box",
		shipping_timing: "Shipping Timing",
		coupons: "Questions About Coupons",
		default: "What do you need help with?",
	},
};
